<template>
  <div class="form">
    <div class="form__header">
      <h3>{{ data ? 'Редактировать' : 'Добавить'}} задание</h3>
    </div>

    <div class="form__body">
      <Input 
        class="form__field"
        v-model="formData.title" 
        label="Название" 
        type="text" 
        id="task-name" 
        :required="true"
      />

      <p class="form__field">
        <span>Группа: </span>
        <v-select 
          :options="levels" 
          v-model="formData.level" 
          :reduce="option => option.id"
          class="required"
          :filterable="false"
          :class="{
            valid: formData.level,
            invalid: !formData.level,
          }"
        >
          <template slot="option" slot-scope="option">
            <div class="d-center">
              {{ option.label }}
              </div>
          </template>
          <template slot="selected-option" slot-scope="option">
            <div class="selected d-center">
              {{ option.label }}
            </div>
          </template>
        </v-select>                
      </p>
    </div>

    <div class="form__footer">
      <SubmitButton @submit="sendForm" :isValid="isValid" />
    </div>
  </div>
</template>

<script>
import { form_mix } from '../../../mixins/form_mix'
import { levels } from './levels'
export default {
  mixins: [ form_mix ],
  props: ['data'],
  inject: ['http', 'contest_id'],
  data() {
    return {
      levels,
      formData: {
        contest_id: this.contest_id,
        title: '',
        level: ''      
      },   
      requiredKeys: ['title', 'level']
    }
  },
  methods: {
    sendForm() {
      let path = this.data ? 'onUpdateMatriusBlock' : 'onCreateMatriusBlock'
      let message = this.data ? 'Задание обновлено' : 'Задание добавлено'
      this.http.post(path, this.formData).then(res => {
        this.$emit('close-popup')
        this.$emit('add-task-block', res.data)        
        swal('Успешно!', message, 'success')
      })
    }
  },
  mounted() {
    if (this.data) {
      this.formData = Object.assign({}, this.data)
    }
  }
}
</script>

